import styles from './SubHeaders.module.css'
import ProjektprognosSnapshots from '../../Snapshots/ProjektprognosSnapshots'
import PeriodReportComparisonInfo from '../../Snapshots/PeriodReportComparisonInfo'
import { useProjektprognosEditingContext } from '../../context/ProjektprognosEditingContext'
import { Badge } from '@fluentui/react-components'

const ProjektprognosSubHeader = () => {
  const { selectedPeriodReport } = useProjektprognosEditingContext()
  const projectInfo = selectedPeriodReport?.projectData

  const { projectManager, name, id } = projectInfo || {}
  const typeName = projectInfo?.type?.name

  const projectHeader: string = name && id ? `${name} - ${id}` : ''
  document.title = projectHeader

  return (
    <div className={styles.subBanner}>
      <div className={`${styles.flexContainer} ${styles.leftSection}`}>
        {projectHeader && (
          <div className={styles.childFlexContainer}>
            <h4 className={styles.subHeader}>{projectHeader}</h4>
            {projectManager && (
              <Badge
                style={{ marginLeft: 12, padding: '0 12px' }}
                size="medium"
                appearance="outline"
              >
                {`Projektledare: ${projectManager}`}
              </Badge>
            )}
            {typeName && (
              <Badge
                style={{ marginLeft: 12, padding: '0 12px' }}
                size="medium"
                appearance="outline"
              >
                {`Projekttyp: ${typeName}`}
              </Badge>
            )}
          </div>
        )}
      </div>
      <div className={`${styles.flexContainer} ${styles.centerSection}`}>
        <PeriodReportComparisonInfo />
      </div>
      <div className={`${styles.flexContainer} ${styles.rightSection}`}>
        <ProjektprognosSnapshots />
      </div>
    </div>
  )
}

export default ProjektprognosSubHeader
